import { CallParticipantListParticipant } from "@azure/communication-react";


/**
 * Participant is prioritized if:
 * - participant is unmuted
 * or
 * - participant has raised hand
 * @param participant
 */
export const isParticipantPrioritized = (participant: CallParticipantListParticipant): boolean =>
    !participant.isMuted || participant.raisedHand !== undefined;


/**
 * Reorders a list of participants:
 * Shows unmuted _or_ raised hand participants first,
 * then sorts by name alphabetically.
 */
export const sortParticipantsByPriority = (a: CallParticipantListParticipant, b: CallParticipantListParticipant): number => {
    // prioritize unmuted participants and participants with raised hand
    const aIsPrioritized = isParticipantPrioritized(a);
    const bIsPrioritized = isParticipantPrioritized(b);

    if (aIsPrioritized && !bIsPrioritized) {
        return -1; // a comes before b
    } else if (!aIsPrioritized && bIsPrioritized) {
        return 1; // b comes before a
    } else {
        // order by name alphabetically if both are prioritized or not prioritized
        const aName = a.displayName?.toLowerCase() || '';
        const bName = b.displayName?.toLowerCase() || '';

        if (aName < bName) {
            return -1; // a comes before b
        } else if (aName > bName) {
            return 1; // b comes before a
        }

        return 0;
    }
};
